var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isPC ? _c('div', {
    staticClass: "message-input"
  }, [_c('FormPC', {
    attrs: {
      "payload": _vm.forwardPayload
    },
    on: {
      "sendMessage": _vm.handleSendForm
    }
  })], 1) : _c('div', [_c('FormMobile', {
    attrs: {
      "payload": _vm.forwardPayload
    },
    on: {
      "sendMessage": _vm.handleSendForm,
      "showFormPopup": _vm.handleShowFormPopup
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }